/**
 * Full-page navigation, in its own module so a test can observe the hand-off
 * without jsdom attempting a real navigation (and so the one place a supporter
 * is sent off-site is greppable).
 */
export function navigateTo(url: string): void {
  window.location.assign(url);
}
